"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.module.css");
var classnames_1 = require("classnames");
var Dimmer = function (_a) {
    var style = _a.style, className = _a.className, onClick = _a.onClick, _b = _a.component, component = _b === void 0 ? 'div' : _b;
    return React.createElement(component, {
        style: style,
        className: classnames_1.default(styles.dimmer, className),
        onClick: onClick,
    });
};
exports.default = Dimmer;
